import React from 'react'
import { makeStyles } from '@material-ui/core'
import { EnrollmentType } from '../../interface/EnrollmentType'
import BusinessInformationStep from './steps/BusinessInformationStep'
import BusinessAddressAndContact from './steps/BusinessAddressAndContact'
import PreviewContainer from '../PreviewContainer'

const jss = () => {
    return {
        mb40: {
            marginBottom: 40
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    item: Record<string, unknown>
    onGoBack(): unknown
    onClickEdit(): unknown
    onClickSubmitPaymentFailed(): unknown
}

/**
 *
 */
const Preview = ({ item, onGoBack, onClickEdit, onClickSubmitPaymentFailed }: PropsInterface): JSX.Element => {
    const styles = useStyles()

    return <PreviewContainer
        item={item}
        titleRight={`Brand ID: ${item.csp_brand_id}`}
        enrollmentType={EnrollmentType.Brand}
        onGoBack={onGoBack}
    >
        <div className={styles.mb40} data-testid='brands-preview'>
            <BusinessInformationStep
                editing={item}
                passData={{}}
                onClickEdit={onClickEdit}
                onClickSubmitPaymentFailed={onClickSubmitPaymentFailed}
                mode='preview'
            />
        </div>
        <div className={styles.mb40}>
            <BusinessAddressAndContact
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
    </PreviewContainer>
}

export default Preview
